var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeBackbtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_1856)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_1856)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_75_1856)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.483 0.0852894L10.3625 4.07221C10.5235 4.20399 10.547 4.44049 10.4161 4.60133C10.2844 4.76217 10.0472 4.78521 9.88684 4.65444L9.76203 4.55223V10.1255C9.76203 10.3329 9.59357 10.5013 9.38603 10.5013H6.3783C6.27854 10.5013 6.18279 10.4617 6.11261 10.391C6.04193 10.3209 6.00233 10.2247 6.00233 10.1255L6.00484 5.99177H4.49846V10.1255C4.49846 10.3329 4.33003 10.5013 4.12249 10.5013H1.11476C0.907221 10.5013 0.738792 10.3329 0.738792 10.1255V4.55223L0.614472 4.65394C0.544291 4.71106 0.460075 4.73912 0.375858 4.73912C0.26758 4.73912 0.159802 4.69202 0.0851102 4.60183C-0.0462276 4.44099 -0.0231683 4.20449 0.137746 4.07271L5.00677 0.0857904C5.14563 -0.0274484 5.34464 -0.0279495 5.483 0.0852894ZM6.75426 9.74967H9.01003V3.93793L5.24538 0.861929L1.49073 3.93642V9.74967H3.74653V5.61597C3.74653 5.40854 3.91496 5.24018 4.12249 5.24018H6.38081C6.48056 5.24018 6.57631 5.27976 6.64649 5.35041C6.71716 5.42056 6.75677 5.51676 6.75677 5.61597L6.75426 9.74967Z",
    fill: "#F58634"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_1856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5007,
    height: 10.5007,
    fill: "white",
    transform: "translate(0 0.000610352)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_1856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5007,
    height: 10.5007,
    fill: "white",
    transform: "translate(0 0.000610352)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_75_1856"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5007,
    height: 10.5007,
    fill: "white",
    transform: "translate(0 0.000610352)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeBackbtn);
export default __webpack_public_path__ + "static/media/home_backbtn.e3e1f02a1c27d57487956a5deecca9f3.svg";
export { ForwardRef as ReactComponent };